//React Library
import React, { useEffect, useState } from "react";

//Material UI Styles
import { makeStyles, withStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import Box from "@material-ui/core/Box";
import FormControl from '@material-ui/core/FormControl';


import { useParams } from "react-router-dom";


// React Multi Email components 
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/style.css';

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";

//Custom Css + Images
import "./emailTemplate.css";

//Custom Components
import swal from "@sweetalert/with-react";

//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";

//Redux
import { useSelector } from "react-redux";

//Others
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useTranslation } from "react-i18next";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

function TemplateReportStyle() {
  const {t} = useTranslation();
  const classes = useStyles();
  const [emails, setEmails] = useState([]);
  const [emailCC, setEmailCC] = useState([]);
  const [subject, setSubject] = useState("");
  const [emailBody, setEmailBody] = useState("<p>Hi</p><p>Please find the attached report with the findings.</p><p>Thanks</p><p>%auditorname%</p>");
  const [fetchedEmailTemp,setFetchedEmailTemp] = useState(null)
const [errorObj,setErrorObj] = useState({})
const [loader, setLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  let history = useHistory();
  let { temp_id,  template_name } = useParams();


  useEffect(() => {
    getEmailTemplate()
  }, [])
  

  console.log("emailBody",emailBody)


  //Save & Edit email template
  async function handleSubmit() {

      let localstorage = localStorage.getItem("UserData");
    var LocalStoragedata = JSON.parse(localstorage);
    let token = LocalStoragedata?.token;

    let errors = {};
    if (emails.length == 0) {
      swal(t("Warning"), t("Atleast One Email Required"), "warning");
    }else if (subject == "") {
      swal(t("Warning"), t("Subject is Required"), "warning");
    }

    if (emailBody == "") {
      swal(t("Warning"), t("Email Body is Required"), "warning");
    }
    setErrorObj(errors);


    if (Object.keys(errors).length === 0) {

      let data = {
        template_id:temp_id,
        to_email:JSON.stringify(emails),
        cc_email:JSON.stringify(emailCC),
        subject:subject,
        body:emailBody
      }
      console.log('Save Data ****>>>>>>>>', data);
      if (fetchedEmailTemp == null) {
        setLoader(true);
        try {
          let template_email = await fetch(GlobalApi + '/EmailTemplate/create_email_template', {
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data) 
          })
          let response = await template_email.json();
          console.log('Create Temp Response *****>>>>>>>>>>>>', response);
          if(response.status === 'Success'){
            setLoader(false);
            swal(t("Success"), t("Email Template has been updated"), "success");
          }
          else {
            setLoader(false);
            console.log('Something went wrong...!!!');
          }
        }
        catch (error) {
          console.log('Error ***>>>>>>>>', error);
          setLoader(false);
        }
      }else {
        try {
          setLoader(true);
          let template_email = await fetch(GlobalApi + '/EmailTemplate/edit_email_template', {
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email_template_id :fetchedEmailTemp?.id,
              to_email:JSON.stringify(emails),
              cc_email:JSON.stringify(emailCC),
              subject:subject,
              body:emailBody
            })
          })
          let response = await template_email.json();
          console.log('Edit Temp Response *****>>>>>>>>>>>>', response);
          if(response.status === 'Success'){
            setLoader(false);
            swal(t("Success"), t("Email Template been updated"), "success");
          }
          else {
            setLoader(false);
            console.log('Something went wrong...!!!');
          }
        }
        catch (error) {
          console.log('Error ***>>>>>>>>', error);
          setLoader(false);
        }
      }
    }
  }
  
  //get email template
  async function getEmailTemplate() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    try {
      let params = {
        template_id: temp_id
      }
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

      let template_email = await fetch(GlobalApi + '/EmailTemplate/get_email_template?' + query, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        }
      })
      let response = await template_email.json();
      console.log('Get Email Temp Response *****>>>>>>>>>>>>', response);
      if (response.data != null) {
        let emails = JSON.parse(response.data.to_email);
        let cc_emails = JSON.parse(response.data.cc_email);
        console.log('Email %%%%>>>', emails);
        console.log('Email CC%%%%>>>', cc_emails);
        setEmails(emails)
        setEmailCC(cc_emails)
        setSubject(response.data.subject)
        setEmailBody(response.data.body)
        // setAuthObj({
        //   email: emails[0],
        //   cc_email: cc_emails[0],
        //   subject: response.data.subject
        // })
        // setEmailTempData(response.data.body);
        setFetchedEmailTemp(response.data);
      }
    }
    catch (error) {
      console.log('Error ***>>>>', error);
    }
  }


  const handleClose = () => {
    setAnchorEl(null);
  };

    const handleClose2 = () => {
    setAnchorEl2(null);
  };


  const handleSubject  = (text) =>{
setSubject(text)
  }

  const editSubject = (data) =>{
    setSubject(subject.concat("%" + data + "%"))
  }

  const editEmail = (data) =>{
    setEmailBody(emailBody.concat("%" + data + "%"))
  }

  let company = useSelector((state) => state.companyReducer.company);

  // React.useEffect(
  //   () => {
  //     setCurrentCompany(company);
  //     let localstorage = localStorage.getItem("UserData");
  //     var data = JSON.parse(localstorage);
  //     setCurrentUser(data);
  //     getTemplates(company);
  //     getStyles();
  //   },
  //   [company]
  // );


  return <>
      <div style={{ width: "100%", padding: "10px 30px", overflow: "hidden", backgroundColor: "#eaf7fe" }}>
        {/* ================================== Top Search and filter bar ========================= */}

        {/* ================================== Recently Created Templates  ========================= */}
        <Grid container justifyContent="flex-start" alignItems="center" spacing={2} className="shadow" style={{ backgroundColor: "white", padding: "5px 0px", borderRadius: "5px", marginTop: "10px", overflowY: "hidden", height: "85vh" }}>
          <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div>
                <p className="label2" style={{ marginBottom: 5, fontSize: 14, marginTop: 7, color: Colors.globalColor8, textTransform: "uppercase" }}>
                  Edit Email Template
                </p>
               
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div>
                <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 7, color: "grey" }}>
                  {company.company_name} {">"} {template_name}
                </p>
              </div>
            </div>
          </Grid>
          <div style={{ overflowY: "auto", height: "70vh", width: "100%", textAlign: "center", padding: "20px" }}>
            <div style={{ maxWidth: "500px" }}>
              <ReactMultiEmail placeholder="To Email" emails={emails} onChange={(_emails) => {
                  setEmails(_emails);
                }} validateEmail={(email) => {
                  return isEmail(email); // return boolean
                }} getLabel={(email, index, removeEmail) => {
                  return <div data-tag key={index}>
                      {email}
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>;
                }} />
              <br />
              <ReactMultiEmail placeholder="Cc Email" emails={emailCC} onChange={(_emails) => {
                  setEmailCC(_emails);
                }} validateEmail={(email) => {
                  return isEmail(email); // return boolean
                }} getLabel={(email, index, removeEmail) => {
                  return <div data-tag key={index}>
                      {email}
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>;
                }} />
              <br />
              <FormControl variant="outlined" fullWidth size="small" className={classes.margin} autoComplete={"off"}>
                {/* <TextField size="small" id="outlined-basic" label="Subject" variant="outlined" autoComplete={"off"} endAdornment={<InputAdornment position="end">Kg</InputAdornment>} /> */}
                <OutlinedInput id="outlined-adornment-password"  value={subject} // type={values.showPassword ? 'text' : 'password'}
                  onChange={(e)=>handleSubject(e.target.value)}
                  placeholder="Subject" endAdornment={<InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={(e) => {
                                            setAnchorEl(e.currentTarget);
                                          }}
                        edge="end">
                        <AddCircleOutlineIcon style={{ color: Colors.globalColor8 }} />
                      </IconButton>
                    </InputAdornment>} />
              </FormControl>

              <Menu id="simple-menu" className="extraMenuBox" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem style={{ cursor: "pointer" }} onClick={()=>editSubject("location")}>
                  Location
                </MenuItem>
                <MenuItem style={{ cursor: "pointer" }} onClick={()=>editSubject("location_code")}>
                  Location Code
                </MenuItem>
                <MenuItem style={{ cursor: "pointer" }} onClick={()=>editSubject("score")}>
                  Score 
                </MenuItem>
                 <MenuItem style={{ cursor: "pointer" }} onClick={()=>editSubject("audit_date")}>
                   Audit Date 
                </MenuItem>
              </Menu>
              <br />
              
              <br />
              <div style={{ position: "relative" }}>
                <CKEditor editor={ClassicEditor}
                 config={{
                  removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                }}
                
                data={emailBody} onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                  }} onChange={(event, editor) => {
                    const data = editor.getData();
                     setEmailBody(data)
                  }} onBlur={(event, editor) => {
                    console.log("Blur.", editor);
                  }} onFocus={(event, editor) => {
                    console.log("Focus.", editor);
                  }} />
                <IconButton style={{ position: "absolute", top: 35, right: 0 }} onClick={(e) => {
                                            setAnchorEl2(e.currentTarget);
                                          }}>
                  <AddCircleOutlineIcon style={{ color: Colors.globalColor8 }} />
                </IconButton>

                <Menu id="simple-menu" className="extraMenuBox" anchorEl={anchorEl2} keepMounted open={Boolean(anchorEl2)} onClose={handleClose2}>
                <MenuItem style={{ cursor: "pointer" }} onClick={()=>editEmail("executive_summary")}>
                  Executive Summary
                </MenuItem>
                <MenuItem style={{ cursor: "pointer" }} onClick={()=>editEmail("auditor_name")}>
                  Auditor Name
                </MenuItem>
              </Menu>


              </div>

              <br />

              <div style={{ textAlign: "left" }}>
                <Button variant="contained" type="submit" className="addBtn" component="span" onClick={()=>handleSubmit()}>
                  {"Save"}
                </Button>
                &nbsp;
                <Button variant="contained" className="cancelBtn">
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Grid>
      </div>
    </>;
}

export default TemplateReportStyle;
